export default __webpack_public_path__ + "static/media/21.1e61f6da.svg";